import { VISIONX_CONSTANTS } from 'src/app/ComponentMap.tsx';

export const normalizePath = (p: string) => (p.length > 1 ? p.replace(/\/+$/, '') : p);

export const isOnLoginPath = () =>
  normalizePath(window.location.pathname) === normalizePath(VISIONX_CONSTANTS.LOGIN_PATH);

export const buildReturnUrl = () => {
  if (isOnLoginPath()) return ''; // prevent nested returnUrl
  return window.location.pathname + window.location.search;
};

export const buildLoginUrl = () => {
  const returnUrl = buildReturnUrl();
  return returnUrl
    ? `${VISIONX_CONSTANTS.LOGIN_PATH}?returnUrl=${encodeURIComponent(returnUrl)}`
    : VISIONX_CONSTANTS.LOGIN_PATH;
};

export const isSafeReturnUrl = (url: string) => {
  if (!url) return false;
  if (!url.startsWith('/')) return false;
  if (url.startsWith('//')) return false;
  return normalizePath(url) !== normalizePath(VISIONX_CONSTANTS.LOGIN_PATH);
};
export type ReturnUrlCheck = {
  returnUrl: string;
  safe: boolean;
};

export const getSearchParams = (input: string): URLSearchParams => {
  // input can be "/login?x", "?x", "x", or absolute URL
  try {
    const u = new URL(input, 'https://local.invalid');
    return u.searchParams;
  } catch {
    return new URLSearchParams(input.startsWith('?') ? input : `?${input}`);
  }
};

export const extractSafeReturnUrl = (
  input: string,
  opts?: { maxDepth?: number },
): ReturnUrlCheck => {
  const maxDepth = opts?.maxDepth ?? 10;

  if (!input) return { returnUrl: '', safe: false };

  let candidate = input;

  for (let i = 0; i < maxDepth; i++) {
    const params = getSearchParams(candidate);
    const nested = params.get('returnUrl');

    if (!nested) break;

    candidate = nested;
  }

  if (!candidate || !isSafeReturnUrl(candidate)) {
    return { returnUrl: '', safe: false };
  }

  return { returnUrl: candidate, safe: true };
};
